import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image1 from "../../../../assets/images/Blog39/image1 systemic lending risk in US.png";
import image2 from "../../../../assets/images/Blog39/image2 fin stocks hit on Thursday.png";
import image3 from "../../../../assets/images/Blog39/image3 HY not worried.png";
import image15 from "../../../../assets/images/Blog39/image15 Friday flows into weakness.png";
import image17 from "../../../../assets/images/Blog39/image17 inst +retail v hedge.jpeg";
import image18 from "../../../../assets/images/Blog39/image18 leveraged flows gone nuts (1).jpeg";
import image9 from "../../../../assets/images/Blog39/image9N.png";
import image11 from "../../../../assets/images/Blog39/image11 MOVE unmoved again.png";
import image21 from "../../../../assets/images/Blog39/image21 SPX H&S confluences.png";
import image22 from "../../../../assets/images/Blog39/image22 gamma 6600-6750.png";
import image19 from "../../../../assets/images/Blog39/image19 NAS100 3 upsides ahead_.png";
import image20 from "../../../../assets/images/Blog39/image20 NAS100W.png";
import image23 from "../../../../assets/images/Blog39/image23 regional banks stress.png";
import image24 from "../../../../assets/images/Blog39/image24 SMH needs a new HH.png";
import image14 from "../../../../assets/images/Blog39/image14 AAII bear rush.png";
import image8 from "../../../../assets/images/Blog39/image8 gold 10 weeks up in a row_.png";
import image33 from "../../../../assets/images/Blog39/image33 GOLD W 9x up.png";
import image35 from "../../../../assets/images/Blog39/image35 silver at halfway house_.jpeg";
import image39 from "../../../../assets/images/Blog39/image39 BTC consolidation done__.png";
import image41 from "../../../../assets/images/Blog39/image41 oil fade .png";
import image44 from "../../../../assets/images/Blog39/image44 us cpi.png";
import image56 from "../../../../assets/images/Blog39/image56 GOLD GVZ clues.png";
import image61 from "../../../../assets/images/Blog39/image61 VIX pop.png";

const Blog39 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – October 20th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Credit Cracks, Fed Crossroads, and the Calm Before the Cut</p>
        <p>
          Markets are oscillating between optimism and unease. After a volatile fortnight marked by regional bank tremors and shifting rate expectations, traders are debating whether this is another
          “buy the dip” opportunity — or the start of something deeper.
        </p>
        <p>
          The anniversary of Black Monday passed quietly, but the mood feels increasingly 2007-esque, with credit cracks surfacing beneath record-high liquidity. Despite systemic murmurs, equities
          remain resilient as institutions and retail investors doubled down. Yet, beneath the calm, hedging activity and leverage signals suggest we may be in the eye of the storm.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Complacency Amid Credit Ripples</p>
              <p>
                2025 continues to surprise. The “peace dividend” narrative returned as Trump’s diplomatic momentum with China boosted sentiment late in the week. Still, traders can’t ignore the credit
                smoke signals — from Zions Bancorp’s $50 million loan charge-off to Western Alliance’s fraud-linked exposures. The regional bank index (KRE) briefly melted down before Friday’s
                rebound.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="systemic lending risk in US"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <div className="relatedImg">
                  <img
                    src={image2}
                    alt="fin stocks hit on Thursday"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Jamie Dimon’s “cockroaches” analogy summed it up perfectly — isolated issues, not an infestation. Markets took it as code for Buy the Dip. Meanwhile, CLO risk re-emerged, echoing
                pre-GFC structures, but this time without liquidity stress — at least for now.
              </p>
              <p>High-yield spreads barely budged, though many suspect that may still come. The calm feels misplaced.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt="HY not worried"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Flows data confirmed that institutions and retail investors piled back in last week — the biggest inflows since November 2022. Hedge funds, however, remain net sellers, signalling deep
                scepticism beneath the surface.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image15}
                    alt="Friday flows into weakness"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=" inst +retail v hedge"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt="leveraged flows gone nuts"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>As one analyst put it, “We’re priced for perfection — and perfection rarely lasts.”</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: The Fed’s Fine Line</p>
              <p>
                The policy landscape is coiled tight. Miran wants a 50bps cut this month, while Waller supports a quarter-point move before pausing. Powell has opened the door for another cut, citing
                deteriorating data, while hawk Musalem surprisingly endorsed a defensive “insurance cut.”
              </p>
              <p>
                Market pricing now sees a <span className="highlightedText"> 99% chance of an October cut,</span> with December cuts already priced in full — a setup ripe for disappointment if the Fed
                slows its pace.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="Fed cut 99% OCT"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Meanwhile, France’s downgrade to ‘A+/A-1’ highlights Europe’s fiscal fragility, with deficits expected to stay elevated through 2028. The IMF’s Georgieva warned AI could become
                “another vehicle of divergence,” emphasising uneven global benefits from the tech boom.
              </p>
              <p>Bond volatility remains subdued — an eerie calm considering credit jitters and policy uncertainty.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt="MOVE unmoved again"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>The analyst’s takeaway: “The market is trading like rate cuts fix everything. History says they don’t.”</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Indecision at the Top</p>
              <p>Equities remain technically constructive but indecisive.</p>
              <p>
                The S&P 500 continues to wrestle with its <span className="highlightedText">gamma boundaries — 6600 remains negative, while 6750 flips positive.</span> A breakout above 6750 opens the
                way to new highs, while a close below 6600 could trigger downside momentum.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt="SPX H&S confluences"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt="gamma 6600–6750"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Nasdaq 100 still struggles to hold above the 20DMA — the doji-laden candles reflect trader hesitation. A break above resistance would confirm a fresh leg higher, but the setup looks
                stretched.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt="NAS100 3 upsides ahead?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image20}
                    alt="NAS100W?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image20)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Regionals (KRE) remain weak, while semiconductors (SMH) need a decisive higher high to sustain momentum.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt="regional banks stress"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt="SMH needs a new HH"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Sentiment-wise, AAII’s survey flipped sharply bearish — a classic contrarian buy signal.</p>

              <div className="relatedImg">
                <img
                  src={image14}
                  alt="AAII bear rush"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image14)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>Still, extreme leverage suggests any surprise downside could trigger a sharp liquidation.</p>

              <div className="relatedImg">
                <img
                  src={image18}
                  alt="leveraged flows gone nuts"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg("image18")}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Credit Scares, Dovish Comfort</p>
              <p>Markets kicked off the week under pressure from regional bank fears but recovered sharply into Friday as Fed speakers turned dovish and China headlines improved.</p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Regional Banks: </span>Fraud-related write-downs reignited systemic worries but faded by week’s end.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Fed Speak: </span> Powell, Waller, and Bowman reinforced expectations for at least one more rate cut in October.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span>Big banks beat across the board, led by JPMorgan and Citi. Liquidity remains abundant.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>Gold’s historic 10-week winning streak faces exhaustion risk; silver saw a sharp corrective flush.
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt="gold 10 weeks up in a row"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt="GOLD W 9x up"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image35}
                    alt="silver at halfway house?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image35)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span>Midweek volatility looked like a positioning shakeout; institutional buying whispers resurfaced.
                  </p>
                </li>

                <div className="relatedImg">
                  <img
                    src={image39}
                    alt="BTC consolidation done?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image39)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil: </span> Weak demand and inventory builds continue to cap rallies.
                  </p>
                </li>
                <div className="relatedImg">
                  <img
                    src={image41}
                    alt="image41oil fade"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image41)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Macro Data Cluster and Earnings Rush</p>
              <p>With the U.S. government still partially shut, only key data like CPI have been exempted. The focus shifts to inflation, PMIs, and a flood of corporate earnings.</p>
              <p className="highlightedText">Monday, October 20, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span> Q3 GDP, Industrial Production, Retail Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">PBoC: </span>Loan Prime Rate decision
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone:</span> German PPI (Sep), Construction Output
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada: </span>Industrial Product & Raw Materials Price Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.:</span> Business Inventories, Capacity Utilisation
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Holiday:</span> Singapore – Diwali
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, October 21, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.K.:</span> Public Sector Borrowing (Sep)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada: </span>CPI (YoY & MoM, Sep)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone: </span>ECB/BIS/CEPR Conference (Frankfurt)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span> Netflix, GE, Coca-Cola, Lockheed Martin, GM
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, October 22, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.K.:</span> CPI (YoY, Sep)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan: </span>Trade Balance (Sep)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.:</span> MBA Mortgage Applications, Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span> Tesla, IBM, AT&T, SAP, Moody’s
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, October 23, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.:</span> Jobless Claims, Existing Home Sales, Fed Balance Sheet
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Eurozone: </span> French Business Survey
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span> Amazon, Intel, Blackstone, Ford, Honeywell, Unilever
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, October 24, 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global:</span> PMI Day — Manufacturing & Services across U.S., EU, Japan, and India
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S.: </span>CPI (YoY 2.9%, MoM 0.3%), Michigan Sentiment, Building Permits
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span> General Dynamics, HCA, Sanofi, Safran, Eni
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image44}
                    alt="us cpi"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image44)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Calm Before the Cut</p>
              <p>The market’s serenity feels deceptive. Credit tremors, record leverage, and overbought metals suggest volatility is lurking beneath the surface.</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br> Range-bound near highs — 6600–6750 remains the make-or-break zone.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br> Momentum is strong but stretched; a tactical pullback looks healthy.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br> Positioning reset nearly complete — November could mark the next upside phase.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br> The October cut is virtually guaranteed; the real question is what happens after.
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image56}
                    alt="GOLD GVZ clues"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image56)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image61}
                    alt="VIX pop"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image61)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>As Yardeni hinted, perhaps the Santa rally has started early. But in a market this leveraged, the real test will come when optimism meets reality.</p>
              <p>
                <span className="highlightedText">Stay nimble. Trade the volatility, not the narrative.</span>
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1hMvBSuQvSRRLLvavRQhWF5ur3sWyJMmwbxHYGmPf4Cw/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog39;
